import { CitiesRequestFilters, QueryParams } from '../../types/interfaces'

export const queriesKeys = {
  cities: {
    all: ['cities'] as const,
    getCities: (filters?: CitiesRequestFilters, noAuth?: boolean) =>
      [...queriesKeys.cities.all, { filters, noAuth }] as const,
    getCityById: (cityId: number) => ['cities', cityId] as const,
  },
  countries: {
    all: ['countries'],
    getCountries: (noAuth?: boolean) =>
      [...queriesKeys.countries.all, { noAuth }] as const,
  },
  documents: {
    getDocuments: ['documents'] as const,
  },
  driverAgreements: {
    all: (uid: string) => ['driver-agreements', uid] as const,
    status: (uid: string, cityHint?: number | string) =>
      ['driver-agreements', uid, 'status', cityHint] as const,
  },
  drivers: {
    getDriverProfile: ['driverProfile'] as const,
  },
  earnings: {
    all: ['earnings'] as const,
    getEarningById: (earningId: number) =>
      [...queriesKeys.earnings.all, earningId] as const,
    getEarningRides: (earningId: number, filters?: QueryParams) =>
      [
        ...queriesKeys.earnings.getEarningById(earningId),
        'rides',
        filters,
      ] as const,
    getEarnings: (filters?: QueryParams) =>
      [...queriesKeys.earnings.all, { filters }] as const,
    getEarningsLetter: () => [...queriesKeys.earnings.all, 'letter'] as const,
    getEarningsStats: () => [...queriesKeys.earnings.all, 'stats'] as const,
    getEarningWeeklyReport: (earningId: number) =>
      [...queriesKeys.earnings.all, earningId, 'weekly-report'] as const,
  },
  provinces: {
    all: ['provinces'],
    getProvinceById: (provinceId: number) => [
      ...queriesKeys.provinces.all,
      provinceId,
    ],
    getProvinceCitiesById: (provinceId: number) => [
      ...queriesKeys.provinces.getProvinceById(provinceId),
      'cities',
    ],
    getProvinces: (filters?: QueryParams, noAuth?: boolean) =>
      [...queriesKeys.provinces.all, { filters, noAuth }] as const,
  },
  trainings: {
    getTrainings: ['trainings'] as const,
  },
  vehicle_photos: {
    all: ['vehicle-photos'],
    getVehiclePhotos: (VehicleId: number) => [
      ...queriesKeys.vehicle_photos.all,
      VehicleId,
    ],
  },
} as const
